<template>
    <section class="page">
        <div id="page-main">
            <h2>Reviews from {{ username }}</h2>
            <p v-show="this.reviews.length==0">There are no reviews by this user</p>
      <div v-for="review in reviews" v-bind:key="review.reviewId" class="review">
          <article>
            <div class="review-info">
                <h4>{{ getBeerName(review.beerID) }}</h4>
              <h4><i 
                    class="fa-solid fa-star"
                    v-for="n in review.rating"
                    v-bind:key="n"
                  ></i></h4>
              <p>{{ review.reviewText }}</p>
              <button class="button" v-on:click="deleteReview(review.reviewId)">Delete Review</button>
            </div>
          </article>
        </div>
        </div>
    </section>
    </template>

<script>
export default {
    data() {
        return {
            paramsId: parseInt(this.$route.params.id),
        }
    },
    methods: {
        getBeerName(id) {
            let beer = this.$store.getters.getBeerByID(id);
            let brewery = this.$store.getters.getBreweryById(beer.brewery_id);
            return beer.beerName + " - " + brewery.breweryName;
        },
        deleteReview(id) {
            this.$store.commit("DELETE_REVIEW",id);
        }
    },
    computed: {
        reviews() {
            return this.$store.getters.getReviewsForUserId(this.paramsId);
        },
        username () {
            let user =  this.$store.getters.getUsernameById(this.paramsId);
            return user.username;
        }
    }
}
</script>

<style>

</style>